import React from 'react';
import { TextFieldBase, ITextFieldPublicProps } from './TextFieldBaseTemp';

export interface ITextFieldProps extends ITextFieldPublicProps {}

export const TextField: React.FC<ITextFieldProps> = (props) => (
  <TextFieldBase testId={`koopa_text-field_${props.name}`} {...props} />
);
